import type { PartyJointDecision } from '@danda/shared';
import type { LobbyState } from './lobbyStore.types';

export const decisionsSlice: Pick<
  LobbyState,
  'partyDecisions' | 'setPartyDecision' | 'updatePartyDecision' | 'clearPartyDecision'
> = {
  partyDecisions: {},

  setPartyDecision: (decision: PartyJointDecision) => (state: LobbyState) => ({
    partyDecisions: {
      ...state.partyDecisions,
      [decision.partyId]: decision,
    },
  }),

  updatePartyDecision:
    (partyId: string, updater: (decision: PartyJointDecision | undefined) => PartyJointDecision) =>
    (state: LobbyState) => {
      const current = state.partyDecisions[partyId];
      const next = updater(current);
      return {
        partyDecisions: {
          ...state.partyDecisions,
          [partyId]: next,
        },
      };
    },

  clearPartyDecision: (partyId: string) => (state: LobbyState) => {
    const { [partyId]: _omit, ...rest } = state.partyDecisions;
    return { partyDecisions: rest };
  },
};
